import React, { Component } from 'react'
import { selectors, actions } from './sagas/reservation';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import './stylesheets/Cheers.sass'

class Cheers extends Component {
  render () {
    return (
    <div className={'cheers-page'}>
      <div className={'cheers-wrapper'}>
        <img alt='Cheers!' src={'Cheers.png'} />
        <div className={'cheers'}>
          Cheers!
        </div>
        <div className={'complete'}>
          Your keg reservation is complete
        </div>
        <div className={'confirmation-email'}>
          You'll receive a confirmation email shortly.
        </div>
        <div className={'reminder-email'}>
          We'll also send you a reminder email the day before your scheduled pick up date.
        </div>
        { this.props.location && this.props.location.state && this.props.location.state.website &&
        <div>
          <a href={`${this.props.location && this.props.location.state && this.props.location.state.website}`}  >
            <button className={'return-button'}>
              Back to Brewery Website
            </button>
          </a>
        </div>
        }
      </div>

    </div>
    )
  }
}

const mapStateToProps = (store) => ({
  publicInfo: selectors.publicInfo(store),
})

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch);

export default (connect(mapStateToProps, mapDispatchToProps)((Cheers)));



// WEBPACK FOOTER //
// ./src/Cheers.jsx